<ng-container *ngIf="(patientDisplayMode$ | async) as displayMode">
  <!-- Patient Card MFE: standard launch, communicates via IteroEventBus -->
  <rx-patient-card
    *ngIf="displayMode === PatientDisplayMode.PatientCard"
  >
  </rx-patient-card>

  <!-- Unified Patients: in-process XState machine component -->
  <rx-unified-patient
    *ngIf="displayMode === PatientDisplayMode.UnifiedPatients"
  >
  </rx-unified-patient>

  <!-- Legacy iframe patient-app: postMessage communication -->
  <ng-container *ngIf="displayMode === PatientDisplayMode.PatientApp">
    <ng-container *ngIf="(patientSectionMode$ | async) as patientSectionVersion">
      <rx-patient-read-only
        [hidden]="patientSectionVersion !== patientSectionVersionEnum.ReadOnly"
        [patient]="patient$ | async"
        [isIntuitiveFlow]="isIntuitiveFlow$ | async"
        [regulatoryDOBMask]="regulatoryDOBMask$ | async"
        [dateFormat]="dateFormat$ | async"
        [isEditButtonVisible]="isEditButtonVisibleForReadOnly$ | async"
        [isClearButtonVisible]="isClearButtonVisibleForReadOnly$ | async"
        [maxPatientLastNameLength]="maxPatientLastNameLength$ | async"
        [isButtonsVisible]="!(isRxFromReferralDoctorAndUserIsScannigCenter$ | async)"
        (patientCleared)="clearPatient()"
        (patientEdited)="editPatient()"
      >
      </rx-patient-read-only>
      <rx-patient-app-inline
        [hidden]="patientSectionVersion !== patientSectionVersionEnum.InlinePatientApp"
      >
      </rx-patient-app-inline>
    </ng-container>
  </ng-container>
</ng-container>
